//  Закомментируйте строку ниже если блок "Спикеры" не будет использоваться
import SpeakersConfiguration from '@/configurations/content/wecloud/speakers'
//  Закомментируйте строку ниже если блок "Партнеры" не будет использоваться
import PartnersConfiguration from '@/configurations/content/wecloud/partners' // @/configurations/content/vtb/partners-dark для темной темы

export default {
  pageTitle: 'T1 Analyst meetup #1',
  logo: {
    image: require('@/assets/logo/LogoT1.svg'), // @/assets/logo/logo-white.svg для темной темы
    alt: 'T1 logo'
  },
//  pageBackgroundImage: require('@/assets/background/background.jpg'), // путь до кастомного фона
  aboutActivity: {
    name: 'T1 Analyst meetup #1',
  description: [
  'Привет, коллега!',
  '15 февраля в 19-00 в лофте "Весна" состоялся T1 Analyst meetup #1 - идеальное событие для аналитиков и всех, кто интересуется этой областью.',
  'Смотри, как это было, на странице ниже.',
  '<img style="margin-right:20px" width="30" height="30" src="assets/image-block/document.png"  align="left">Почитай доклады',
  '<ul><li>Наталья Семенова и Анна Храмцова: <a href="https://sigma.disk.t1.cloud/public/gGcqZA_I">Вступительное слово</a></li><li>Варвара Ржанникова: <a href="https://sigma.disk.t1.cloud/public/MunnCA_I">Как приблизиться к идеалу документации на проекте</a></li><li>Наталья Казакова: <a href="https://sigma.disk.t1.cloud/public/7uGL6A_I">Командная ретроспектива как инструмент бизнес-аналитика</a></li><li>Анна Мозер: <a href="https://sigma.disk.t1.cloud/public/maRdeA_I">GET запросы на практике: правила, принципы и примеры</a></li><li>Елена Краковская: <a href="https://sigma.disk.t1.cloud/public/8s6juA_I">Борьба за приоритеты: выбираем техники скоринга для управления продуктом</a></li></ul>',
  '<img style="margin-right:20px" width="30" height="30" src="assets/image-block/star-rating.png"  align="left"><a href="http://bit.ly/t1career" target="_blank">Загляни на нашу страницу с вакансиями!</a>'
  ],
  date: '15.02.2024',
  time: '19:00-22:00'
  },
  activities: [
    {
      tabName: '15.06.3023', // название таба, при многозальном мероприятии
      items: [
        {
          hash: 'xgnyrhCa',
          id: 1882,
          hallName: 'Первый зал' // название зала
        //   },
        //   {
        //     hash: 'PXBhAboi',
        //     id: 1106,
        //     hallName: 'Второй зал'
        }
      ]
    }
    // {
    //   tabName: '16.06.3023',
    //   items: [
    //     {
    //       hash: 'MAclQpGI',
    //       id: 1357,
    //       hallName: 'Третий зал'
    //     }
    //   ]
    // }
  ],
  player: {
    title: 'Трансляция' // заголовок блока "Плеер"
  },
  schedule: {
    title: 'Программа' // заголовок блока "Расписание"
  },
  speakers: {
    //  Закомментируйте строку ниже если блок "Спикеры" не будет использоваться
    items: SpeakersConfiguration,
    title: 'Спикеры', // заголовок блока "Спикеры"
    shape: 'circle' // форма фотографий спикеров ('square' - квадрат, 'circle' - круг)
  },
  imageBlock: {
    title: 'Как добраться:', // заголовок Блока с картинкой (оставить пустым (''), если не нужен)
    image: require('@/assets/image-block/Map.png'), // путь до изображения для блока с картинкой
    items: [
      'м. Красносельская/Бауманская, Спартаковский переулок 2с1, подъезд №7 (арт-пространство "Весна", 2 этаж).',
      '<a href="https://yandex.ru/maps/-/CDutqPJk" target="_blank">Яндекс.Карты</a>'
    ]
  },
  info: {
    title: 'О площадке', // заголовок Текстового блока (оставить пустым (''), если не нужен)
    items: [
      'Данный блок достаточно гибкий, в него можно поместить текст, картинки и ссылки по аналогии с первый блоком на данной странице. Часто сюда попадает та информация, о которой хотят сказать организаторы, но которую не считают настолько нужной, чтобы помещать ее перед плеером.'
    ]
  },
  partners: {
    //  Закомментируйте строку ниже если блок "Партнеры" не будет использоваться
    items: PartnersConfiguration,
    title: 'Партнеры' // заголовок блока "Партнёры"
  },
  footer: {
    copyright: '© Холдинг Т1,'
    // phone: '+7 926 260 53 22'
  }
}
